import * as React from 'react';
import { type HTMLAttributes, type ReactNode, forwardRef } from 'react';

import { use$ } from '@legendapp/state/react';
import styled from 'styled-components';

import { containerStore, fullscreenStore } from '../../store';

interface Props {
	children: ReactNode;
}

const ViewWrapper = forwardRef<HTMLDivElement, Props & HTMLAttributes<HTMLDivElement>>(
	({ children, ...props }, ref) => {
		const isFullscreenMode = use$(fullscreenStore.isFullscreenMode);
		const combinedHeight = use$(containerStore.combinedHeight);

		return (
			<ProductViewWrapper ref={ref} isFullscreenMode={isFullscreenMode} heightOffset={combinedHeight} {...props}>
				{children}
			</ProductViewWrapper>
		);
	}
);

ViewWrapper.displayName = 'View-Wrapper';

const ProductViewWrapper = styled.div<{
	isFullscreenMode: boolean;
	heightOffset: number;
}>`
	// IMPORTANT! This prevents other parts of FA from overflowing things like NBAB
	z-index: 0;
	display: grid;
	grid-template-columns: repeat(24, 1fr);
	grid-template-rows: repeat(24, 1fr);

	// Required to prevent overflow to lower components when zooming
	overflow: hidden;

	// Required for bottom-control-panel as it exists outside grid
	position: relative;

	// TODO: remove and see if Rachel doesn't notice
	// Hack for android simulators and unsupported browsers that do not support new viewport units
	height: ${({ isFullscreenMode, heightOffset }) =>
		isFullscreenMode ? '100%' : `calc(100vh - ${heightOffset ?? 0}px)`};
	height: ${({ isFullscreenMode, heightOffset }) =>
		isFullscreenMode ? '100%' : `calc(100lvh - ${heightOffset ?? 0}px)`};
`;

export default ViewWrapper;
